import { useMutation } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';

interface IProps {
    customerId: string;
    accountExternalId: string;
    serviceItemId: string;
}

export const useDeleteProduct = () => useMutation(
  'useDeleteProduct',
  async ({
    customerId, accountExternalId, serviceItemId,
  }: IProps) => {
    const res = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/invoice/serviceItem/${serviceItemId}`);
    return res.data;
  },
  { retry: 0 },
);
